import script from "./MouseSelection.vue?vue&type=script&lang=ts&setup=true"
export * from "./MouseSelection.vue?vue&type=script&lang=ts&setup=true"

import "./MouseSelection.vue?vue&type=style&index=0&id=2c5e1d42&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c5e1d42"]])

export default __exports__